import { render, staticRenderFns } from "./WechatService.vue?vue&type=template&id=607a54f6&scoped=true&"
import script from "./WechatService.vue?vue&type=script&lang=js&"
export * from "./WechatService.vue?vue&type=script&lang=js&"
import style0 from "./WechatService.vue?vue&type=style&index=0&id=607a54f6&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a54f6",
  null
  
)

export default component.exports